export type CreateSupportTicketArgs = {
  faqEntryId: number
  ch?: string
  problemTextId?: string | Array<string>
  transactionId?: number | null
  threadId?: number
  sessionId?: string
  singleFile?: boolean
  tempUuid?: string | Array<string>
  attachmentType?: string
  photoEntryId?: string
  photoChanged?: boolean
  preview?: boolean
  message: string
  isEnglishAllowed?: boolean | null
  itemId?: number | null
  memberId?: number | null
  email?: string | null
  helpCenterSessionId?: string | null
}

export const getCreateSupportTicketArgs = ({
  faqEntryId,
  ch,
  problemTextId,
  transactionId,
  threadId,
  tempUuid,
  message,
  isEnglishAllowed,
  itemId,
  memberId,
  email,
  helpCenterSessionId,
}: CreateSupportTicketArgs) => ({
  faq_entry_id: faqEntryId,
  ch,
  transaction_id: transactionId,
  thread_id: threadId,
  problem_text_id: problemTextId,
  temp_uuid: tempUuid,
  help_contact_form: {
    message,
    english_allowed: isEnglishAllowed,
    item_id: itemId,
    transaction_id: transactionId,
    member_id: memberId,
    email,
  },
  help_center_session_id: helpCenterSessionId,
})

export type CreateSupportTicketResp = {
  user_msg_thread_id?: number
}
